import PropTypes from "prop-types";
import React from "react";

const ToolbarSection = props => {
  const { className, ...rest } = props;
  return (
    <div
      className={`toolbar__section ${className ? className : ""}`}
      {...rest}
    />
  );
};

ToolbarSection.propTypes = {
  className: PropTypes.string,
};

export default ToolbarSection;



// WEBPACK FOOTER //
// ./casper/sass/components/toolbar/toolbar-section.js